import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import PpcOverTimeAccounts from './components/Page';

const PpcOverTimeAccountsPage = () => (
  <Container className="dashboard">
    <Row>
      <Col md={12}>
        <h3 className="page-title">PPC Over Time Account</h3>
      </Col>
    </Row>
    <Row>
      <PpcOverTimeAccounts />
    </Row>
  </Container>
);

export default PpcOverTimeAccountsPage;
